import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function MarqueeStrip() {
  const { t } = useLang();
  return (
    <section data-testid="marquee-section" className="border-y border-border bg-secondary/40 py-6 overflow-hidden">
      <Marquee speed={55} gradient={false} autoFill>
        {t.marquee.map((w, i) => (
          <div key={i} className="flex items-center gap-8 px-8">
            <span className="font-heading text-2xl md:text-3xl font-bold tracking-tight text-foreground/90">
              {w}
            </span>
            <Star className="h-5 w-5 text-primary fill-primary" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
